import { render, staticRenderFns } from "./MyReviewIndex.vue?vue&type=template&id=4e3773a8&scoped=true&"
import script from "./MyReviewIndex.vue?vue&type=script&lang=js&"
export * from "./MyReviewIndex.vue?vue&type=script&lang=js&"
import style0 from "./MyReviewIndex.vue?vue&type=style&index=0&id=4e3773a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3773a8",
  null
  
)

export default component.exports